import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import axios from 'axios';
import Slider from 'react-slick';

import Header from './header';
import Footer from './footer';
import apiUrl from './base_url';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../components/cssfile/question_paper.css';
import '../components/cssfile/home.css';

const Home = () => {
  const [addcategory, setAddcategory] = useState([]);
  const [message, setMessage] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    axios
      .get(apiUrl + 'serverside/message.php')
      .then(response => {
        setMessage(response.data);
      })
      .catch(error => {
        console.error(error);
      });

    axios
      .get(apiUrl + 'serverside/parentcategory.php')
      .then(response => {
        setAddcategory(response.data);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  /*
   * =========================================================
   * ADD TEST SERIES
   * ORIGINAL LOGIC PRESERVED
   * =========================================================
   */
  const addSeries = (event, category) => {
    event.preventDefault();

    const regid = localStorage.getItem('regid');

    if (!regid) {
      window.location.href = '/login';
      return;
    }

    axios
      .post(apiUrl + 'serverside/addseries.php', {
        category,
        regid
      })
      .then(() => {
        window.location.href = '/dashboard';
      })
      .catch(error => {
        console.error(error);
        alert('An error occurred. Please try again.');
      });
  };

  /*
   * =========================================================
   * TEST SERIES FILTER
   * ORIGINAL LOGIC PRESERVED
   * =========================================================
   */
  const filteredCategories = addcategory.filter(item =>
    item.status == 1 &&
    item.topic_name &&
    item.topic_name
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  /*
   * =========================================================
   * LATEST 5 ANNOUNCEMENTS
   *
   * We take the last 5 records returned by the API.
   *
   * IMPORTANT:
   * This assumes message.php returns announcements in
   * oldest -> newest order.
   *
   * If your API returns newest -> oldest, change this to:
   *
   * const latestMessages = message.slice(0, 5);
   * =========================================================
   */
  const latestMessages = message.slice(-5);

  /*
   * =========================================================
   * ANNOUNCEMENT SLIDER
   * =========================================================
   */
  const sliderSettings = {
    dots: true,
    infinite: latestMessages.length > 3,
    speed: 500,
    slidesToShow: Math.min(3, latestMessages.length),
    slidesToScroll: 1,
    autoplay: latestMessages.length > 1,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: latestMessages.length > 1,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: Math.min(3, latestMessages.length),
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: Math.min(2, latestMessages.length),
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div className="et-home">

      {/* =====================================================
          HEADER
          ===================================================== */}
      <Header />


      {/* =====================================================
          HERO
          ===================================================== */}
      <section className="et-home-hero">

        <div className="et-home-hero-overlay">

          <div className="et-home-hero-content">

            <div className="et-hero-badge">
              ERWATODAY
            </div>

            <h1>
              Prepare Smarter.
              <br />
              <span>Perform Better.</span>
            </h1>

            <p>
              Select your preferred test series and start your
              competitive exam preparation with focused online mock tests.
            </p>

            <div className="et-hero-buttons">

              <a
                href="#test-series"
                className="et-hero-primary"
              >
                Explore Test Series
              </a>

              <Link
                to="/dashboard"
                className="et-hero-secondary"
              >
                My Dashboard
              </Link>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          ANNOUNCEMENTS
          ONLY LATEST 5 ARE SHOWN
          ===================================================== */}

      {latestMessages.length > 0 && (

        <section className="et-announcement-section">

          <div className="et-section-heading">

            <div>

              <span className="et-section-label">
                LATEST UPDATES
              </span>

              <h2>
                Announcements
              </h2>

              <p>
                Important updates and information
              </p>

            </div>

          </div>


          <div className="et-announcement-slider">

            <Slider {...sliderSettings}>

              {latestMessages.map((item, index) => (

                <div
                  key={item.id || index}
                  className="et-slider-column"
                >

                  <div className="et-announcement-card">

                    <div className="et-announcement-top">

                      <span className="et-announcement-badge">
                        UPDATE
                      </span>

                      <span className="et-announcement-number">
                        {String(index + 1).padStart(2, '0')}
                      </span>

                    </div>


                    <div className="et-announcement-content">

                      {ReactHtmlParser(item.des)}

                    </div>

                  </div>

                </div>

              ))}

            </Slider>

          </div>

        </section>

      )}


      {/* =====================================================
          TEST SERIES
          ===================================================== */}

      <section
        id="test-series"
        className="et-test-series-section"
      >

        <div className="et-series-header">

          <div className="et-series-heading">

            <span className="et-section-label">
              TEST LIBRARY
            </span>

            <h2>
              Online Mock Test Series
            </h2>

            <p>
              Choose a test series and begin your preparation.
            </p>

          </div>


          {/* =================================================
              SEARCH
              ================================================= */}

          <div className="et-series-search">

            <span className="et-search-icon">
              🔍
            </span>

            <input
              type="text"
              placeholder="Search test series..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            {searchTerm && (

              <button
                type="button"
                onClick={() => setSearchTerm('')}
                className="et-search-clear"
                aria-label="Clear search"
              >
                ×
              </button>

            )}

          </div>

        </div>


        {/* =====================================================
            TEST SERIES GRID
            ===================================================== */}

        <div className="et-series-grid">

          {filteredCategories.length > 0 ? (

            filteredCategories.map((item, index) => (

              <div
                key={item.category || index}
                className="et-series-card"
              >

                {/* IMAGE */}

                <div className="et-series-image-area">

                  <img
                    src={item.image}
                    alt={item.topic_name}
                    className="et-series-image"
                  />

                  <span className="et-series-available">
                    Available
                  </span>

                </div>


                {/* CONTENT */}

                <div className="et-series-card-body">

                  <h3>
                    {item.topic_name}
                  </h3>

                  <p>
                    Practice with online mock tests and
                    improve your exam preparation.
                  </p>


                  {/* ADD SERIES */}

                  <button
                    type="button"
                    className="et-series-start-button"
                    onClick={(e) =>
                      addSeries(e, item.category)
                    }
                  >

                    <span>
                      Get Started Now
                    </span>

                    <span className="et-arrow">
                      →
                    </span>

                  </button>

                </div>

              </div>

            ))

          ) : (

            /* =================================================
               NO SERIES
               ================================================= */

            <div className="et-no-series">

              <div className="et-no-series-icon">
                🔍
              </div>

              <h3>
                No Test Series Found
              </h3>

              <p>
                Try searching with another keyword.
              </p>

              {searchTerm && (

                <button
                  type="button"
                  className="et-clear-search-button"
                  onClick={() => setSearchTerm('')}
                >
                  Clear Search
                </button>

              )}

            </div>

          )}

        </div>

      </section>


      {/* =====================================================
          FOOTER
          ===================================================== */}

      <Footer />

    </div>
  );
};

export default Home;